import { Provider } from "react-redux";
import { consoleLog, setGlobalVar } from "./miscellaneous/helpers";
import { GLOBAL_VARS } from "./constants";
import { AppAnalyticsService } from "./app-analytics/AppAnalyticsService";
import FirebaseService from "./services/FirebaseService";
import { store } from "./redux/store";
import NavStart from "./navigation";
import { FaCircleCheck } from "react-icons/fa6";
import {
  DefaultTheme,
  NavigationContainer,
  useNavigationContainerRef,
} from "@react-navigation/native";
import {
  isReadyRef,
  routeNameRef,
} from "./miscellaneous/helpers/RootNavigation";
import { ToastContainer } from "react-toastify";
import { CloseIcon } from "./icons";
import { COLORS } from "./config/colors";
import { useEffect, useRef } from "react";
import config from "./config/config";
import { APP_ENV, APP_NAME, CLARITY_PROJECT_ID } from "./config/setting";
import "./App.css";
import { THEME_COLORS } from "./theme/constants/themeColors";
import Clarity from "@microsoft/clarity";
import LoggerService from "./miscellaneous/services/LoggerSerivce";
import { isEmpty } from "lodash";

const CloseButton = ({ closeToast }) => {
  return (
    <div style={{ marginTop: 10 }}>
      <CloseIcon onClick={closeToast} fill={COLORS.whiteColor} />
    </div>
  );
};

// ref: https://github.com/jhen0409/react-native-debugger/blob/master/docs/network-inspect-of-chrome-devtools.md#how-it-works
window.XMLHttpRequest = (window as any).originalXMLHttpRequest
  ? (window as any).originalXMLHttpRequest
  : window.XMLHttpRequest;
window.FormData = (window as any).originalFormData
  ? (window as any).originalFormData
  : window.FormData;

// fetch; // Ensure to get the lazy property

if ((window as any).__FETCH_SUPPORT__) {
  // it's RNDebugger only to have
  (window as any).__FETCH_SUPPORT__.blob = false;
} else {
  /*
   * Set __FETCH_SUPPORT__ to false is just work for `fetch`.
   * If you're using another way you can just use the native Blob and remove the `else` statement
   */
  window.Blob = (window as any).originalBlob
    ? (window as any).originalBlob
    : window.Blob;
  window.FileReader = (window as any).originalFileReader
    ? (window as any).originalFileReader
    : window.FileReader;
}

setGlobalVar(GLOBAL_VARS.AppAnalytics, new AppAnalyticsService());
setGlobalVar(GLOBAL_VARS.FirebaseServiceInstance, new FirebaseService());

const AppWithStore = () => {
  const navigationRef = useNavigationContainerRef();

  const getVariant = () => {
    const root = document.querySelector('#root');
    const variant = root?.getAttribute('data-app-variant');
    if (variant) {
      GLOBAL_VARS.AppVariant = variant as string;
      config.WHITE_LABEL_ID = variant;
    }
  };

  const ingressRoute = useRef<string | undefined>('');

  const initializeClarity = () => {
    if (!!CLARITY_PROJECT_ID && APP_ENV === 'prod') {
      Clarity.init(CLARITY_PROJECT_ID);
      Clarity.setTag("APP_NAME", APP_NAME);
      LoggerService.simpleLog('Telemetry', 'Clarity initialized');
    }
    else {
      LoggerService.simpleLog('Telemetry', 'Clarity not initialized', CLARITY_PROJECT_ID, APP_ENV);
    }
  };

  useEffect(() => {

    // (window as any).navigation?.addEventListener("navigate", (event) => {
    //   console.log('location changed', routeNameRef.current, window.location.pathname);
    //   if (!routeNameRef.current && window.location.pathname.replace('/','') !== routeNameRef.current) { 
    //     navigationRef?.current?.navigate(routeNameRef.current as never);
    //   }
    // })

    getVariant();

    initializeClarity();
  }, []);

  return (
    <Provider store={store}>
      <NavigationContainer
        // @ts-ignore
        theme={{
          // ref: https://stackoverflow.com/a/60801578/4331993
          // ref: https://reactnavigation.org/docs/themes/
          // ref: https://github.com/react-navigation/react-navigation/issues/9811#issuecomment-901724207
          colors: {
            ...DefaultTheme.colors,
            background: 'transparent',
          },
        }}
        ref={navigationRef}
        onReady={() => {
          const actualScreenName = navigationRef?.getCurrentRoute()?.name;
          LoggerService.simpleLog('onReady', ingressRoute.current, actualScreenName);
          routeNameRef.current = `${ingressRoute.current}/${actualScreenName}`;

          // initial
          // routeNameRef.current = navigationRef?.getCurrentRoute()?.name;
          isReadyRef.current = true;
          document.title = APP_NAME;
        }}
        onStateChange={() => {
          // const ingressRoute = window.location.pathname;
          if (!ingressRoute.current && window.location.pathname?.includes('tm-lite')) { 
            ingressRoute.current = '/tm-lite';
          }

          LoggerService.simpleLog('ingressRoute', ingressRoute.current);

          const previousRouteName = routeNameRef.current;
          const actualScreenName = navigationRef?.getCurrentRoute()?.name;
          // const initialRouteFull = initialRoute?.current || window.location.pathname;
          const currentRouteName = `${ingressRoute.current}/${actualScreenName}`;
          const params = navigationRef?.getCurrentRoute()?.params || {};

          document.title = APP_NAME;
          
          LoggerService.simpleLog('state', previousRouteName, `->`, currentRouteName, params);

          if (!isEmpty(params)) {
            LoggerService.simpleLog('updating params', params);
            const queryParams = new URLSearchParams();
            Object.entries(params).forEach(([key, value]) => {
              if (value !== undefined && value !== null) {
                queryParams.append(key, String(value));
              }
            });
            const queryString = queryParams.toString();
            const url = queryString ? `${currentRouteName}?${queryString}` : currentRouteName;
            window.history.pushState({ params }, "", url);
          } 
          else if (previousRouteName !== currentRouteName) {
            window.history.pushState({ params }, "", currentRouteName);
          }

          // Save the current route name for later comparison
          routeNameRef.current = currentRouteName;
        }}>

        <NavStart />

        <ToastContainer
          closeButton={CloseButton}
          icon={({ type }) => {
            if (type === "success")
              return <FaCircleCheck color={COLORS.whiteColor} size={20} />;
            // if (type === 'error') return '🚨';
            // else return 'ℹ️';
          }}
        />
      </NavigationContainer>
    </Provider>
  );
};

export default AppWithStore;
